const UUID_REGEXP = /U'(.*)'/;

const parseIdentifierField = (value) => {
  if (typeof value === 'string') {
    try {
      return value.match(UUID_REGEXP)[1];
    } catch (ex) {
      // ignored exception
    }
  }
  return value;
};

export default class BaseModel {
  constructor(opts = {}) {
    this.id = parseIdentifierField(opts['@id']);
    this.name = opts['@COMMON_NAME'] || null;
    this.relAttr = parseIdentifierField(opts['@REL_ATTR']);
  }
}
